import { Route } from 'vue-router'
import { Component, Watch } from 'vue-property-decorator'
import { faPlay, faPlus, faCheck, faRedo } from '@fortawesome/free-solid-svg-icons'

import { TaskLifecycleStates } from '@skinsoft/types'
import { taskSelectors } from '@skinsoft/selectors'
import { EntityDataStore } from '@skinsoft/entity-data-store'
import { ReactiveVue } from '@skinsoft/reactive-vue'

import {
    CREATE_COMPLEX_MOVEMENT_FROM_TASK_TOPIC,
    CREATE_SIMPLE_MOVEMENT_FROM_TASK_TOPIC,
    REJECT_TASK_TOPIC,
    START_TASK_TOPIC,
    TERMINATE_TASK_TOPIC,
} from '../../../../busTopics'

@Component({
    props: ['entityDataStore'],
    template: require('./action-menu-task.html'),
})
export class ActionMenuTask extends ReactiveVue {
    public plusIcon = faPlus
    public playIcon = faPlay
    public backIcon = faRedo
    public checkIcon = faCheck
    public entityDataStore: EntityDataStore<any>
    public entity: any = null
    public $route: Route

    public canCreate: boolean = false
    public canStartTask: boolean = false
    public canRejectTask: boolean = false
    public canTerminateTask: boolean = false

    public get noPossibleActions() {
        return !this.canCreate && !this.canStartTask && !this.canTerminateTask && !this.canTerminateTask
    }

    public createComplexMovement() {
        this.emitOnBus(CREATE_COMPLEX_MOVEMENT_FROM_TASK_TOPIC)
        this.$emit('toggle')
    }

    public createSimpleMovement() {
        this.emitOnBus(CREATE_SIMPLE_MOVEMENT_FROM_TASK_TOPIC)
        this.$emit('toggle')
    }

    public rejectTask() {
        this.emitOnBus(REJECT_TASK_TOPIC)
        this.$emit('toggle')
    }

    public startTask() {
        this.emitOnBus(START_TASK_TOPIC)
        this.$emit('toggle')
    }

    public terminateTask() {
        this.emitOnBus(TERMINATE_TASK_TOPIC)
        this.$emit('toggle')
    }

    public created() {
        this.subscribeToEntity()
    }

    public subscribeToEntity() {
        this.subscribeTo(
            this.entityDataStore.fetchOne(this.$route.params.id),
            (entity) => {
                this.entity = entity
            },
            'entity',
        )
    }

    @Watch('$route', { deep: true })
    @Watch('entityDataStore')
    public onDataStoreChange() {
        this.unsubscribeFrom('entity')
        this.subscribeToEntity()
    }

    @Watch('entity', { deep: true, immediate: true })
    public onEntityChange(entity) {
        const linkableItems = taskSelectors.linkableItems(entity)
        this.canCreate = linkableItems.length > 0 && taskSelectors.state(entity) !== TaskLifecycleStates.FINALIZED

        // SHOULD BE LINK TO REAL DATA ONCE API IS READY
        this.canRejectTask = taskSelectors.state(entity) === TaskLifecycleStates.IN_PROGRESS
        this.canStartTask = taskSelectors.state(entity) === TaskLifecycleStates.PLANNED
        this.canTerminateTask = taskSelectors.state(entity) === TaskLifecycleStates.IN_PROGRESS
    }
}
